import {
  Component,
  ChangeDetectionStrategy,
  AfterContentInit,
  ElementRef,
  OnDestroy, Input
} from '@angular/core';
import { DocsPopService } from '../docs-pop/docs-pop.service';

const DATA_ATTR = 'data-zui-docs';
const DATA_ATTR_NEW = 'data-zui-new-docs';

@Component({
  selector: 'zui-docs-text',
  templateUrl: './docs-text.component.html',
  styleUrls: [ './docs-text.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ZuiDocsTextComponent implements AfterContentInit, OnDestroy {

  @Input()
  initDelay = 0;

  private _els: NodeList;

  constructor(
    private _elementRef: ElementRef,
    private _docsPopService: DocsPopService
  ) {
    this._attachDomListeners();
  }

  ngAfterContentInit() {
    this._attachDomListeners();
    setTimeout(() => this._attachDomListeners(), this.initDelay);
  }

  ngOnDestroy() {
    this._removeDomListeners();
  }

  refreshListeners() {
    this._removeDomListeners();
    this._attachDomListeners();
  }

  private _onClick(e: Event, el: HTMLElement) {

    e.preventDefault();

    /**
     * Actually, there are two variants, how links to Zerops documentation is done.
     * The first is the old one using data-zui-docs attribute on <a> tags. They are all inactive.
     * The second is the new one using data-zui-new-docs attribute on <a> tags. When used they are shown.
     * When the migration is finished, the support for the first variant should be removed from code.
     */
    const entity = el.getAttribute(DATA_ATTR) ?? el.getAttribute(DATA_ATTR_NEW);

    this._docsPopService.setEntity(entity);

    const ref = this._docsPopService.getRef();

    ref.open();
  }

  private _attachDomListeners() {
    if (!this._els?.length) {
      /**
       * The old variant. After migration this one should be removed.
       */
      this._els = this._elementRef.nativeElement.querySelectorAll('[data-zui-docs]');

      /**
       * The support for the new variant. After the migration this one should the default one.
       */
      if (!this._els?.length) {
        this._els = this._elementRef.nativeElement.querySelectorAll('[data-zui-new-docs]');
      }

      this._els?.forEach((node: any) => {

        const textContent = node.textContent.split(' ');

        const lastItem = `<span>${textContent.pop()}</span>`;

        node.innerHTML = `${textContent.join(' ')} ${lastItem}`;

        node.addEventListener('click', (e: Event) => this._onClick(e, node));

      });
    }
  }

  private _removeDomListeners() {
    this._els?.forEach((node: any) => node.removeEventListener('click', (e) => this._onClick(e, node)));
  }

}
